import React, { useMemo } from 'react';
import SignOffTable, { type SnapRow as TableSnapRow } from '@/components/SignOffTable';

export function SignoffView({ data, readOnly = true, headerExtras }: { data: any[]; readOnly?: boolean; headerExtras?: React.ReactNode }) {
  const flatRows = (data || []) as unknown as TableSnapRow[];

  // Group into per-store/per-operator tables (match sign-off-v2). No dedupe here; show raw rows.
  const storeOperatorGroups = useMemo(() => {
    const groupMap = new Map<string, { storeId: any; operatorId: any; storeName: string; operatorName: string; assignments: TableSnapRow[] }>();
    for (const r of flatRows) {
      const storeId = (r as any).storeId ?? (r as any).store_id;
      const operatorId = (r as any).operatorId ?? (r as any).operator_id;
      const key = `${storeId}-${operatorId}`;
      if (!groupMap.has(key)) {
        groupMap.set(key, {
          storeId,
          operatorId,
          storeName: (r as any).storeName ?? 'Unknown Store',
          operatorName: (r as any).operatorName ?? 'Unknown Operator',
          assignments: [] as TableSnapRow[],
        });
      }
      groupMap.get(key)!.assignments.push(r);
    }

    return Array.from(groupMap.values());
  }, [flatRows]);

  return (
    <div className="space-y-6">
      {headerExtras ? <div>{headerExtras}</div> : null}
      {storeOperatorGroups.length === 0 ? (
        <SignOffTable rows={flatRows} />
      ) : (
        storeOperatorGroups.map((g) => (
          <div key={`${g.storeId}-${g.operatorId}`}>
            <div className="text-sm font-medium text-gray-700 mb-2">{g.storeName} — {g.operatorName}</div>
            <SignOffTable rows={g.assignments} />
          </div>
        ))
      )}
    </div>
  );
}

export default SignoffView;


